module.exports = __webpack_public_path__ + "static/media/photo_wrong_example1.d182bfdd.JPG";